import { images } from './images';
import ImageWrapper from '../components/ImageWrapper';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { useState } from 'react';
import { Fullscreen, Zoom } from 'yet-another-react-lightbox/plugins';

export default function GalleryPage() {
    const [open, setOpen] = useState(false);
    const [lightboxIndex, setIndex] = useState();

    return (
        <div className="page__width flex flex-col my-12">
            {Object.keys(images).map((key) => {
                return (
                    <>
                        <div className='w-full flex items-end justify-between'>
                        <h2 className="text-3xl lg:text-5xl text-white text-center lg:text-start">
                            {key}
                        </h2>
                        <a href={`/gallery/${images[key].route}`} className='text-sm animated_link text-brand'>View All</a>
                        </div>
                        <div className="flex justify-between my-8 flex-wrap">
                            {images[key].images.slice(0, 4).map((img, index) => {
                                return <ImageWrapper key={index} src={img.src} className="w-64 h-64" object='cover'/>
                            })}
                        </div>
                    </>
                );
            })}
        </div>
    );
}
